import { formatCurrency } from './currency';

export function txLabels(tx, t) {
  const isCancelled = tx.cancelled;
  const paymentLabel = t('checks.payment');
  return {
    isCancelled,
    typeLabel: isCancelled
      ? t('status.cancelled')
      : (tx.type === 'payment' || tx.type === 'deposit')
        ? paymentLabel
        : tx.type === 'refund'
          ? t('checks.txRefund')
          : t('checks.txCharge'),
    typeColor: isCancelled ? 'default' : (tx.type === 'payment' || tx.type === 'deposit') ? 'success' : tx.type === 'refund' ? 'warning' : 'error',
    amountSign: (tx.type === 'payment' || tx.type === 'deposit') ? '+' : tx.type === 'charge' ? '-' : '+',
    amountColor: isCancelled ? 'text.disabled' : tx.type === 'charge' ? 'error.main' : 'success.main',
  };
}

export function formatPaymentAmount(tx, fallbackCurrency) {
  const amountSign = (tx.type === 'payment' || tx.type === 'deposit') ? '+' : tx.type === 'charge' ? '-' : '+';
  const currency = tx.currency || fallbackCurrency;
  return `${amountSign}${formatCurrency(tx.amount, currency)}`;
}
